import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TASK_CLASS_LABELS } from "@/lib/api";

const SCORE_LABELS = { effort: "Effort", rest: "Rest", sharpness: "Sharpness", readiness: "Readiness" };

function cellColor(v) {
  const mag = Math.min(Math.abs(v) / 9, 1);
  if (v > 0.3) return { background: `rgba(22,163,74,${0.12 + mag * 0.5})` };
  if (v < -0.3) return { background: `rgba(220,38,38,${0.12 + mag * 0.5})` };
  return {};
}

export default function Correlations() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/ml/correlations").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="p-8 text-sm text-muted-foreground">Loading model…</div>;

  return (
    <div>
      <header className="h-16 border-b border-border flex items-center px-8 gap-4 sticky top-0 bg-background z-10">
        <h1 className="font-heading text-xl font-black tracking-tight">Correlation Model</h1>
        <span className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">Ridge-learned weights · task class → score</span>
      </header>
      <div className="p-8">
        <p className="text-sm text-muted-foreground max-w-2xl mb-6">
          These weights are learned by a Ridge regression trained on the cleaned activity log. Each value is how much one unit of load in a task class moves a score per day. Green = raises the score, red = lowers it. This is the correlation layer the simulator projects forward.
        </p>
        <div className="border border-border overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-xs tracking-[0.15em] uppercase font-bold text-muted-foreground">
                <th className="text-left p-3">Task Class</th>
                {data.scores.map((s) => <th key={s} className="text-right p-3">{SCORE_LABELS[s]}</th>)}
              </tr>
            </thead>
            <tbody>
              {data.classes.map((c) => (
                <tr key={c} className="border-b border-border last:border-0" data-testid={`corr-row-${c}`}>
                  <td className="p-3 font-medium">{TASK_CLASS_LABELS[c]}</td>
                  {data.scores.map((s) => {
                    const v = data.correlations[c][s];
                    return <td key={s} className="p-3 text-right tabular-nums font-medium" style={cellColor(v)}>{v > 0 ? "+" : ""}{v}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
